import React from 'react';
import TestPilotPage from './TestPilotPage';

const App: React.FC = () => {
    return <TestPilotPage />;
};

export default App;
